import Model from 'src/storage/base';

class SettingInvoicesModel extends Model {
  id = 'SettingInvoicesModel';
  defaultState = () => ({
    loading: false,
    changed: false,
    serie: '',
    nextNumber: ''
  });
  persistent = false;
  apiConfig = {
    update: {
      url: 'profile/update/invoice',
      validation: {
        serie: 'string',
        nextNumber: 'nextNumber'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  onHandleChangeProfile = (profile) => {
    this.setState({ ...(profile.invoice || { serie: 'LIFEAPP', nextNumber: 1 }) });
  };

  reset = () => {
    let user = this.state.user;
    this.resetApiState('update');
    this.setState({
      ...this.defaultState(),
      ...(user.invoice || { serie: 'LIFEAPP', nextNumber: 1 })
    });
  };

  save = () => {
    let req = {
      serie: this.state.serie,
      nextNumber: parseInt(this.state.nextNumber)
    };
    this.api('update', req, (error, data, success) => {
      if (success) {
        this.setState({ loading: false, changed: false });
      }
    });
  };
}

const model = new SettingInvoicesModel();
export default model;
